export const VALIDGUESSES = [
    'अईग',
    'अईद',
    'अईन',
    'अईर',
    'अईल',
    'अकट',
    'अकड',
    'अकथ',
    'अकम',
    'अकय',
    'अकर',
    'अकल',
    'अकस',
    'अखत',
    'अखर',
    'अखल',
    'अगई',
    'अगग',
    'अगड',
    'अगद',
    'अंगद',
    'अगन',
    'अगप',
    'अगम',
    'अगर',
    'अगल',
    'अगस',
    'अघई',
    'अघट',
    'अघड',
    'अघर',
    'अघळ',
    'अचक',
    'अचर',
    'अचल',
    'अचळ',
    'अजक',
    'अजग',
    'अजज',
    'अजड',
    'अजत',
    'अजद',
    'अजन',
    'अजप',
    'अजफ',
    'अजब',
    'अजम',
    'अजय',
    'अजर',
    'अजल',
    'अजष',
    'अजस',
    'अजह',
    'अझई',
    'अझत',
    'अझद',
    'अझन',
    'अझम',
    'अझर',
    'अझल',
    'अटक',
    'अटख',
    'अटग',
    'अटच',
    'अटत',
    'अटन',
    'अटम',
    'अटर',
    'अटल',
    'अटळ',
    'अटव',
    'अठक',
    'अठव',
    'अडई',
    'अडक',
    'अडख',
    'अडच',
    'अडण',
    'अडत',
    'अडद',
    'अडन',
    'अडप',
    'अडम',
    'अडर',
    'अडल',
    'अडव',
    'अडस',
    'अढळ',
    'अणत',
    'अणद',
    'अणव',
    'अतक',
    'अतन',
    'अतर',
    'अतल',
    'अथक',
    'अथन',
    'अथम',
    'अथर',
    'अथल',
    'अथव',
    'अदक',
    'अदद',
    'अदन',
    'अदब',
    'अदम',
    'अदय',
    'अदर',
    'अदल',
    'अदळ',
    'अदस',
    'अदह',
    'अधई',
    'अधक',
    'अधण',
    'अधन',
    'अधम',
    'अधर',
    'अधल',
    'अधळ',
    'अधव',
    'अनई',
    'अनक',
    'अनग',
    'अनघ',
    'अनट',
    'अनत',
    'अनथ',
    'अनन',
    'अनफ',
    'अनम',
    'अनय',
    'अनल',
    'अनळ',
    'अनस',
    'अपघ',
    'अपच',
    'अपण',
    'अपन',
    'अपय',
    'अपर',
    'अपल',
    'अपस',
    'अपह',
    'अफक',
    'अफन',
    'अफफ',
    'अफर',
    'अफल',
    'अफळ',
    'अबई',
    'अबक',
    'अबज',
    'अबद',
    'अबन',
    'अबब',
    'अबर',
    'अबल',
    'अबळ',
    'अबव',
    'अबस',
    'अभई',
    'अभग',
    'अभद',
    'अभन',
    'अभम',
    'अभय',
    'अभर',
    'अभव',
    'अभस',
    'अमक',
    'अमच',
    'अमज',
    'अमण',
    'अमत',
    'अमद',
    'अमन',
    'अमप',
    'अमय',
    'अमर',
    'अमल',
    'अमळ',
    'अमव',
    'अमस',
    'अमह',
    'अयत',
    'अयन',
    'अयब',
    'अयम',
    'अयर',
    'अयस',
    'अरक',
    'अरग',
    'अरज',
    'अरड',
    'अरण',
    'अरत',
    'अरथ',
    'अरन',
    'अरब',
    'अरम',
    'अरर',
    'अरल',
    'अरळ',
    'अरव',
    'अरस',
    'अलई',
    'अलक',
    'अलख',
    'अलग',
    'अलघ',
    'अलट',
    'अलड',
    'अलन',
    'अलफ',
    'अलम',
    'अलय',
    'अलल',
    'अलस',
    'अलह',
    'अळई',
    'अळण',
    'अळम',
    'अळव',
    'अवई',
    'अवक',
    'अवग',
    'अवघ',
    'अवज',
    'अवड',
    'अवत',
    'अवद',
    'अवध',
    'अवन',
    'अवर',
    'अवल',
    'अवळ',
    'अवस',
    'अशआ',
    'अशई',
    'अशक',
    'अशत',
    'अशद',
    'अशन',
    'अशफ',
    'अशब',
    'अशय',
    'अशर',
    'अशव',
    'अशश',
    'अशस',
    'अशह',
    'असअ',
    'असआ',
    'असई',
    'असच',
    'असज',
    'असट',
    'असण',
    'असत',
    'असथ',
    'असद',
    'असन',
    'असफ',
    'असब',
    'असभ',
    'असम',
    'असय',
    'असर',
    'असल',
    'असळ',
    'असव',
    'असश',
    'असस',
    'असह',
    'अस�',
    'अहद',
    'अहन',
    'अहम',
    'अहर',
    'अहल',
    'अहव',
    'अहह',
    'आअज',
    'आअठ',
    'आआआ',
    'आआद',
    'आआप',
    'आईई',
    'आईक',
    'आईग',
    'आईच',
    'आईज',
    'आईट',
    'आईड',
    'आईत',
    'आईन',
    'आईफ',
    'आईय',
    'आईर',
    'आईल',
    'आईव',
    'आईस',
    'आकई',
    'आकक',
    'आकड',
    'आकत',
    'आकर',
    'आकश',
    'आकस',
    'आखच',
    'आखड',
    'आखण',
    'आखत',
    'आखफ',
    'आखर',
    'आखल',
    'आगई',
    'आगग',
    'आगच',
    'आगट',
    'आगठ',
    'आगड',
    'आगत',
    'आगद',
    'आगन',
    'आगम',
    'आगर',
    'आगल',
    'आगळ',
    'आगस',
    'आघई',
    'आघत',
    'आघन',
    'आघळ',
    'आचन',
    'आचर',
    'आचल',
    'आचळ',
    'आचव',
    'आजच',
    'आजड',
    'आजण',
    'आजत',
    'आजद',
    'आजन',
    'आजप',
    'आजब',
    'आजम',
    'आजय',
    'आजर',
    'आजल',
    'आजव',
    'आजह',
    'आझद',
    'आझम',
    'आझर',
    'आटक',
    'आटत',
    'आटप',
    'आटम',
    'आटर',
    'आटल',
    'आटळ',
    'आटव',
    'आटश',
    'आटस',
    'आठक',
    'आठच',
    'आठण',
    'आठळ',
    'आठव',
    'आडक',
    'आडच',
    'आडण',
    'आडत',
    'आडन',
    'आडप',
    'आडम',
    'आडर',
    'आडल',
    'आडव',
    'आडस',
    'आढक',
    'आढळ',
    'आढव',
    'आणक',
    'आणख',
    'आणच',
    'आणण',
    'आणत',
    'आणन',
    'आणप',
    'आणल',
    'आतच',
    'आतज',
    'आतड',
    'आतण',
    'आतन',
    'आतम',
    'आतर',
    'आतल',
    'आतळ',
    'आतश',
    'आतष',
    'आतह',
    'आथक',
    'आथर',
    'आदई',
    'आदक',
    'आदग',
    'आदज',
    'आदण',
    'आदत',
    'आदद',
    'आदन',
    'आदप',
    'आदब',
    'आदम',
    'आदय',
    'आदर',
    'आदल',
    'आदळ',
    'आदश',
    'आधई',
    'आधक',
    'आधण',
    'आधन',
    'आधप',
    'आधम',
    'आधर',
    'आधव',
    'आनक',
    'आनत',
    'आनद',
    'आनन',
    'आनप',
    'आनफ',
    'आनम',
    'आनय',
    'आनल',
    'आनव',
    'आनश',
    'आपक',
    'आपच',
    'आपट',
    'आपण',
    'आपत',
    'आपद',
    'आपन',
    'आपम',
    'आपय',
    'आपर',
    'आपल',
    'आपस',
    'आफक',
    'आफण',
    'आफत',
    'आफन',
    'आफप',
    'आफर',
    'आफळ',
    'आबई',
    'आबक',
    'आबच',
    'आबड',
    'आबळ',
    'आभआ',
    'आभड',
    'आभय',
    'आभर',
    'आमच',
    'आमट',
    'आमण',
    'आमत',
    'आमद',
    'आमन',
    'आमय',
    'आमर',
    'आमल',
    'आयई',
    'आयक',
    'आयच',
    'आयज',
    'आयझ',
    'आयट',
    'आयड',
    'आयत',
    'आयद',
    'आयन',
    'आयप',
    'आयब',
    'आयम',
    'आयय',
    'आयर',
    'आयल',
    'आयव',
    'आयश',
    'आयष',
    'आयस',
    'आरई',
    'आरख',
    'आरग',
    'आरच',
    'आरज',
    'आरड',
    'आरण',
    'आरत',
    'आरथ',
    'आरद',
    'आरन',
    'आरप',
    'आरफ',
    'आरब',
    'आरभ',
    'आरम',
    'आरल',
    'आरळ',
    'आरव',
    'आरश',
    'आरस',
    'आरह',
    'आलई',
    'आलच',
    'आलट',
    'आलण',
    'आलत',
    'आलध',
    'आलन',
    'आलप',
    'आलफ',
    'आलम',
    'आलय',
    'आलल',
    'आलव',
    'आलश',
    'आलस',
    'आळआ',
    'आळई',
    'आळख',
    'आळण',
    'आळत',
    'आळव',
    'आळश',
    'आळस',
    'आवई',
    'आवक',
    'आवग',
    'आवज',
    'आवट',
    'आवड',
    'आवढ',
    'आवण',
    'आवत',
    'आवद',
    'आवध',
    'आवन',
    'आवय',
    'आवर',
    'आवल',
    'आवळ',
    'आवव',
    'आवस',
    'आवह',
    'आशआ',
    'आशक',
    'आशत',
    'आशन',
    'आशब',
    'आशम',
    'आशय',
    'आशर',
    'आशष',
    'आषण',
    'आषय',
    'आसई',
    'आसच',
    'आसट',
    'आसण',
    'आसत',
    'आसद',
    'आसन',
    'आसफ',
    'आसब',
    'आसम',
    'आसय',
    'आसर',
    'आसल',
    'आसळ',
    'आसव',
    'आसश',
    'आसस',
    'आसह',
    'आहग',
    'आहच',
    'आहज',
    'आहट',
    'आहण',
    'आहत',
    'आहद',
    'आहन',
    'आहम',
    'आहर',
    'आहल',
    'आहव',
    'आहह',
    'ईअर',
    'ईआई',
    'ईआन',
    'ईआय',
    'ईआर',
    'ईईई',
    'ईकड',
    'ईकत',
    'ईगत',
    'ईगन',
    'ईगर',
    'ईगल',
    'ईचक',
    'ईचम',
    'ईजय',
    'ईजर',
    'ईझम',
    'ईझल',
    'ईटन',
    'ईटर',
    'ईटस',
    'ईडन',
    'ईतक',
    'ईतन',
    'ईतम',
    'ईतर',
    'ईथच',
    'ईथन',
    'ईथर',
    'ईदर',
    'ईधन',
    'ईधर',
    'ईनफ',
    'ईनम',
    'ईनर',
    'ईपब',
    'ईबझ',
    'ईमई',
    'ईयन',
    'ईयर',
    'ईरई',
    'ईरड',
    'ईरम',
    'ईलम',
    'ईलय',
    'ईलस',
    'ईवन',
    'ईवम',
    'ईवर',
    'ईशत',
    'ईशन',
    'ईशर',
    'ईशल',
    'ईषत',
    'ईषद',
    'ईषय',
    'ईसन',
    'ईसफ',
    'ईसब',
    'ईसम',
    'ईसर',
    'ईसह',
    'कआय',
    'कईक',
    'कईच',
    'कईल',
    'कईस',
    'ककक',
    'ककट',
    'ककड',
    'ककत',
    'ककर',
    'ककळ',
    'ककश',
    'कखग',
    'कगज',
    'कगद',
    'कगन',
    'कचई',
    'कचक',
    'कचच',
    'कचत',
    'कचम',
    'कचर',
    'कचव',
    'कजज',
    'कजन',
    'कजप',
    'कजम',
    'कजय',
    'कजर',
    'कझन',
    'कझर',
    'कटई',
    'कटक',
    'कटच',
    'कटत',
    'कटप',
    'कटर',
    'कटल',
    'कटस',
    'कठक',
    'कठन',
    'कडई',
    'कडक',
    'कडच',
    'कडड',
    'कडत',
    'कडन',
    'कडप',
    'कडम',
    'कडल',
    'कडळ',
    'कडव',
    'कडस',
    'कढई',
    'कढण',
    'कढत',
    'कढय',
    'कढर',
    'कढल',
    'कढळ',
    'कढव',
    'कणई',
    'कणक',
    'कणग',
    'कणच',
    'कणद',
    'कणन',
    'कणम',
    'कणव',
    'कणस',
    'कतआ',
    'कतई',
    'कतर',
    'कतल',
    'कथक',
    'कथच',
    'कथन',
    'कथल',
    'कदअ',
    'कदई',
    'कदक',
    'कदत',
    'कदम',
    'कदर',
    'कदल',
    'कदस',
    'कधई',
    'कधच',
    'कधळ',
    'कनक',
    'कनड',
    'कनत',
    'कनन',
    'कनप',
    'कनब',
    'कनय',
    'कनल',
    'कनव',
    'कनस',
    'कपक',
    'कपच',
    'कपट',
    'कपड',
    'कपत',
    'कपन',
    'कपर',
    'कपल',
    'कफच',
    'कफज',
    'कफन',
    'कफर',
    'कफस',
    'कफह',
    'कबअ',
    'कबज',
    'कबड',
    'कबन',
    'कबर',
    'कबस',
    'कमई',
    'कमज',
    'कमठ',
    'कमत',
    'कमद',
    'कमन',
    'कमर',
    'कमल',
    'कमळ',
    'कमव',
    'कमष',
    'कयत',
    'कयन',
    'कयम',
    'कयल',
    'करई',
    'करक',
    'करच',
    'करज',
    'करट',
    'करड',
    'करढ',
    'करण',
    'करत',
    'करथ',
    'करद',
    'करन',
    'करप',
    'करभ',
    'करम',
    'करय',
    'करर',
    'करल',
    'करळ',
    'करव',
    'करश',
    'करस',
    'करह',
    'कलआ',
    'कलई',
    'कलक',
    'कलग',
    'कलच',
    'कलठ',
    'कलड',
    'कलत',
    'कलथ',
    'कलन',
    'कलप',
    'कलफ',
    'कलब',
    'कलम',
    'कलय',
    'कलर',
    'कलल',
    'कलव',
    'कलश',
    'कलष',
    'कलस',
    'कलह',
    'कळक',
    'कळच',
    'कळण',
    'कळत',
    'कळथ',
    'कळद',
    'कळन',
    'कळप',
    'कळब',
    'कळम',
    'कळल',
    'कळव',
    'कळश',
    'कळस',
    'कळह',
    'कवई',
    'कवक',
    'कवच',
    'कवट',
    'कवठ',
    'कवड',
    'कवण',
    'कवत',
    'कवन',
    'कवय',
    'कवर',
    'कवल',
    'कवळ',
    'कवष',
    'कवह',
    'कशन',
    'कशप',
    'कशफ',
    'कशल',
    'कसई',
    'कसक',
    'कसग',
    'कसच',
    'कसत',
    'कसद',
    'कसन',
    'कसब',
    'कसम',
    'कसय',
    'कसर',
    'कसल',
    'कसव',
    'कसस',
    'कहक',
    'कहत',
    'कहन',
    'कहप',
    'कहर',
    'कहल',
    'कहस',
    'खअड',
    'खअल',
    'खआण',
    'खआन',
    'खआस',
    'खईम',
    'खकत',
    'खकन',
    'खखर',
    'खगच',
    'खचच',
    'खचण',
    'खचत',
    'खचन',
    'खचर',
    'खचव',
    'खजन',
    'खजर',
    'खटक',
    'खटच',
    'खटझ',
    'खटन',
    'खटल',
    'खटळ',
    'खठड',
    'खडई',
    'खडक',
    'खडख',
    'खडग',
    'खडज',
    'खडत',
    'खडन',
    'खडप',
    'खडम',
    'खडल',
    'खडस',
    'खढठ',
    'खणच',
    'खणण',
    'खणत',
    'खणन',
    'खतक',
    'खतच',
    'खतम',
    'खतर',
    'खतल',
    'खदळ',
    'खनक',
    'खनज',
    'खनन',
    'खनल',
    'खपच',
    'खपण',
    'खपत',
    'खपव',
    'खबर',
    'खबळ',
    'खमक',
    'खमग',
    'खमण',
    'खमन',
    'खमम',
    'खमर',
    'खमस',
    'खयच',
    'खयम',
    'खयव',
    'खरक',
    'खरग',
    'खरच',
    'खरज',
    'खरट',
    'खरड',
    'खरण',
    'खरत',
    'खरद',
    'खरप',
    'खरब',
    'खरम',
    'खरय',
    'खरल',
    'खरव',
    'खरस',
    'खलक',
    'खलच',
    'खलज',
    'खलत',
    'खलद',
    'खलप',
    'खलफ',
    'खलल',
    'खलश',
    'खलष',
    'खळई',
    'खळक',
    'खळग',
    'खळत',
    'खळद',
    'खळब',
    'खळळ',
    'खवट',
    'खवड',
    'खवत',
    'खवर',
    'खवल',
    'खवळ',
    'खसम',
    'खहक',
    'खहल',
    'गअर',
    'गईल',
    'गईस',
    'गकई',
    'गकत',
    'गगग',
    'गगड',
    'गगण',
    'गगन',
    'गगल',
    'गघक',
    'गचक',
    'गजक',
    'गजच',
    'गजट',
    'गजन',
    'गजब',
    'गजर',
    'गजल',
    'गझक',
    'गझब',
    'गझर',
    'गझल',
    'गटई',
    'गटक',
    'गटग',
    'गटच',
    'गटत',
    'गटब',
    'गटर',
    'गटल',
    'गटस',
    'गठई',
    'गठण',
    'गठन',
    'गडक',
    'गडख',
    'गडग',
    'गडच',
    'गडड',
    'गडत',
    'गडद',
    'गडप',
    'गडब',
    'गडम',
    'गडर',
    'गडल',
    'गडस',
    'गढई',
    'गढक',
    'गढत',
    'गढद',
    'गणक',
    'गणच',
    'गणत',
    'गणन',
    'गणम',
    'गणल',
    'गणश',
    'गणह',
    'गतग',
    'गतच',
    'गतम',
    'गदक',
    'गदग',
    'गदड',
    'गदन',
    'गदप',
    'गदम',
    'गदर',
    'गदळ',
    'गधक',
    'गधड',
    'गनई',
    'गनच',
    'गनन',
    'गनर',
    'गपच',
    'गफर',
    'गफह',
    'गबन',
    'गबर',
    'गमक',
    'गमच',
    'गमण',
    'गमत',
    'गमन',
    'गमप',
    'गमय',
    'गमर',
    'गरक',
    'गरग',
    'गरच',
    'गरज',
    'गरठ',
    'गरड',
    'गरत',
    'गरद',
    'गरप',
    'गरब',
    'गरम',
    'गरल',
    'गरळ',
    'गरश',
    'गरस',
    'गलअ',
    'गलई',
    'गलक',
    'गलट',
    'गलत',
    'गलथ',
    'गलफ',
    'गळक',
    'गळग',
    'गळच',
    'गळठ',
    'गळण',
    'गळत',
    'गळद',
    'गळप',
    'गवई',
    'गवड',
    'गवत',
    'गवय',
    'गवर',
    'गवल',
    'गवळ',
    'गवस',
    'गषत',
    'गसन',
    'गहच',
    'गहण',
    'गहन',
    'गहम',
    'गहर',
    'घईल',
    'घघळ',
    'घझल',
    'घटक',
    'घटच',
    'घटट',
    'घटत',
    'घटन',
    'घटम',
    'घटर',
    'घटल',
    'घडई',
    'घडक',
    'घडच',
    'घडण',
    'घडत',
    'घडन',
    'घडय',
    'घडल',
    'घडव',
    'घडस',
    'घढल',
    'घणत',
    'घणस',
    'घतक',
    'घतत',
    'घतल',
    'घथक',
    'घदल',
    'घनक',
    'घनच',
    'घनन',
    'घपत',
    'घमत',
    'घयक',
    'घयत',
    'घरच',
    'घरज',
    'घरट',
    'घरड',
    'घरण',
    'घरत',
    'घरथ',
    'घरन',
    'घरफ',
    'घरम',
    'घलई',
    'घलण',
    'घलत',
    'घळई',
    'घळण',
    'घसअ',
    'घसक',
    'घसट',
    'घसण',
    'घसत',
    'घसर',
    'चअर',
    'चईन',
    'चईप',
    'चकक',
    'चकट',
    'चकण',
    'चकत',
    'चकन',
    'चकम',
    'चकर',
    'चकल',
    'चकव',
    'चखड',
    'चखल',
    'चगल',
    'चघळ',
    'चचड',
    'चचल',
    'चटई',
    'चटक',
    'चटच',
    'चटण',
    'चटत',
    'चटप',
    'चटम',
    'चटर',
    'चठख',
    'चडई',
    'चडत',
    'चडव',
    'चढई',
    'चढच',
    'चढण',
    'चढत',
    'चढन',
    'चढल',
    'चढव',
    'चणक',
    'चतर',
    'चथम',
    'चदन',
    'चनई',
    'चनक',
    'चनच',
    'चनन',
    'चनल',
    'चनस',
    'चपई',
    'चपक',
    'चपट',
    'चपड',
    'चपत',
    'चपय',
    'चपर',
    'चपल',
    'चपळ',
    'चपस',
    'चबक',
    'चबड',
    'चमक',
    'चमख',
    'चमच',
    'चमथ',
    'चमन',
    'चमर',
    'चमस',
    'चयन',
    'चरअ',
    'चरई',
    'चरक',
    'चरख',
    'चरच',
    'चरट',
    'चरड',
    'चरण',
    'चरत',
    'चरथ',
    'चरन',
    'चरप',
    'चरम',
    'चरस',
    'चलक',
    'चलण',
    'चलत',
    'चलद',
    'चलन',
    'चलम',
    'चलल',
    'चलह',
    'चळक',
    'चळच',
    'चळण',
    'चळत',
    'चळव',
    'चवई',
    'चवक',
    'चवच',
    'चवठ',
    'चवड',
    'चवढ',
    'चवण',
    'चवथ',
    'चवन',
    'चवर',
    'चवल',
    'चवळ',
    'चवस',
    'चशक',
    'चषक',
    'चषख',
    'चषट',
    'चषर',
    'चसक',
    'चहक',
    'चहड',
    'चहत',
    'चहर',
    'चहल',
    'जईद',
    'जईम',
    'जकड',
    'जकब',
    'जकर',
    'जकळ',
    'जखड',
    'जखम',
    'जखर',
    'जखल',
    'जगच',
    'जगड',
    'जगण',
    'जगत',
    'जगद',
    'जगध',
    'जगन',
    'जगब',
    'जगभ',
    'जगम',
    'जगर',
    'जगल',
    'जगह',
    'जघन',
    'जचक',
    'जजई',
    'जजक',
    'जजच',
    'जजप',
    'जजर',
    'जझर',
    'जझल',
    'जटट',
    'जठर',
    'जडच',
    'जडण',
    'जडत',
    'जडन',
    'जडप',
    'जडल',
    'जढझ',
    'जढण',
    'जढर',
    'जणक',
    'जणच',
    'जतण',
    'जतन',
    'जतब',
    'जतर',
    'जथर',
    'जदत',
    'जदय',
    'जदर',
    'जदल',
    'जधव',
    'जनक',
    'जनग',
    'जनच',
    'जनत',
    'जनन',
    'जनम',
    'जनर',
    'जनल',
    'जनळ',
    'जनश',
    'जनस',
    'जपच',
    'जपण',
    'जपत',
    'जपन',
    'जपम',
    'जपल',
    'जपश',
    'जफर',
    'जबड',
    'जबर',
    'जबल',
    'जबळ',
    'जभर',
    'जमक',
    'जमच',
    'जमज',
    'जमण',
    'जमत',
    'जमन',
    'जमल',
    'जमव',
    'जमस',
    'जयक',
    'जयच',
    'जयत',
    'जयद',
    'जयन',
    'जयम',
    'जयर',
    'जयल',
    'जयश',
    'जयस',
    'जरग',
    'जरच',
    'जरज',
    'जरठ',
    'जरड',
    'जरण',
    'जरत',
    'जरब',
    'जरल',
    'जलई',
    'जलक',
    'जलग',
    'जलच',
    'जलज',
    'जलण',
    'जलत',
    'जलद',
    'जलन',
    'जलब',
    'जलम',
    'जलय',
    'जलल',
    'जलश',
    'जलस',
    'जळक',
    'जळच',
    'जळज',
    'जळण',
    'जळत',
    'जळन',
    'जळल',
    'जळव',
    'जवक',
    'जवण',
    'जवत',
    'जवद',
    'जवन',
    'जवम',
    'जवर',
    'जवल',
    'जवळ',
    'जवस',
    'जशन',
    'जसई',
    'जसन',
    'जसस',
    'जहग',
    'जहज',
    'जहन',
    'जहर',
    'जहल',
    'झअल',
    'झईन',
    'झईस',
    'झकच',
    'झकण',
    'झकत',
    'झकल',
    'झकस',
    'झखम',
    'झगड',
    'झगल',
    'झझई',
    'झझझ',
    'झटक',
    'झटत',
    'झठज',
    'झठझ',
    'झडच',
    'झडण',
    'झडत',
    'झडप',
    'झडब',
    'झणक',
    'झणण',
    'झतक',
    'झनई',
    'झनक',
    'झनन',
    'झनब',
    'झनय',
    'झपक',
    'झपट',
    'झपड',
    'झफर',
    'झबर',
    'झबल',
    'झमक',
    'झमन',
    'झयद',
    'झरण',
    'झरत',
    'झरप',
    'झरर',
    'झलक',
    'झलत',
    'झळक',
    'झळच',
    'झळत',
    'झळप',
    'झवत',
    'झवन',
    'झवय',
    'झवर',
    'झवल',
    'झहर',
    'टईम',
    'टकअ',
    'टकक',
    'टकत',
    'टकर',
    'टकल',
    'टकळ',
    'टखन',
    'टखर',
    'टगन',
    'टगर',
    'टचप',
    'टचल',
    'टटल',
    'टठर',
    'टणक',
    'टतर',
    'टनक',
    'टनच',
    'टनन',
    'टनल',
    'टनस',
    'टपक',
    'टपर',
    'टफढ',
    'टफन',
    'टमक',
    'टमन',
    'टरक',
    'टरच',
    'टरन',
    'टरस',
    'टलस',
    'टळक',
    'टळत',
    'टळल',
    'टवट',
    'टवन',
    'टवर',
    'टवळ',
    'टवस',
    'टशन',
    'टसन',
    'टसर',
    'टसल',
    'टसह',
    'टहल',
    'ठआर',
    'ठकन',
    'ठकर',
    'ठकळ',
    'ठगच',
    'ठगण',
    'ठगन',
    'ठढख',
    'ठढज',
    'ठणक',
    'ठणण',
    'ठतत',
    'ठपक',
    'ठबक',
    'ठभर',
    'ठरक',
    'ठरच',
    'ठरण',
    'ठरत',
    'ठरल',
    'ठरव',
    'ठलक',
    'ठळअ',
    'ठळक',
    'ठळख',
    'ठवत',
    'ठवर',
    'ठवळ',
    'ठसण',
    'ठसत',
    'ठसन',
    'ठहर',
    'डईफ',
    'डकट',
    'डकर',
    'डकव',
    'डगन',
    'डगर',
    'डगल',
    'डगळ',
    'डघड',
    'डचड',
    'डजन',
    'डझन',
    'डटन',
    'डडड',
    'डडब',
    'डणत',
    'डनम',
    'डपय',
    'डपर',
    'डफच',
    'डफड',
    'डफर',
    'डफल',
    'डफळ',
    'डबई',
    'डबक',
    'डबर',
    'डबल',
    'डबळ',
    'डभई',
    'डमक',
    'डमन',
    'डमर',
    'डयट',
    'डयल',
    'डरत',
    'डरथ',
    'डरल',
    'डवग',
    'डवर',
    'डवव',
    'डशन',
    'डसत',
    'डसन',
    'डसल',
    'डहर',
    'डहल',
    'ढकम',
    'ढकर',
    'ढकल',
    'ढकळ',
    'ढगच',
    'ढगत',
    'ढगळ',
    'ढडक',
    'ढतड',
    'ढबच',
    'ढमक',
    'ढरअ',
    'ढरप',
    'ढलई',
    'ढलन',
    'ढलप',
    'ढळक',
    'ढळत',
    'ढवण',
    'ढवन',
    'ढवर',
    'ढवळ',
    'ढवस',
    'ढसत',
    'ढसळ',
    'ढहळ',
    'ढहश',
    'णकर',
    'णखर',
    'णझअ',
    'णझख',
    'तअर',
    'तईच',
    'तईत',
    'तईप',
    'तईम',
    'तकत',
    'तकद',
    'तकम',
    'तकय',
    'तकर',
    'तखत',
    'तगई',
    'तगच',
    'तगट',
    'तगड',
    'तगत',
    'तगर',
    'तटक',
    'तटत',
    'तटथ',
    'तटर',
    'तटस',
    'तडक',
    'तडख',
    'तडज',
    'तडण',
    'तडत',
    'तडन',
    'तडप',
    'तडफ',
    'तडम',
    'तडव',
    'तडस',
    'तढत',
    'तणच',
    'तणन',
    'तणव',
    'तणस',
    'ततच',
    'ततड',
    'ततन',
    'ततप',
    'ततर',
    'तथव',
    'तधळ',
    'तनक',
    'तनन',
    'तनय',
    'तनल',
    'तपक',
    'तपच',
    'तपण',
    'तपत',
    'तपन',
    'तपल',
    'तपश',
    'तपस',
    'तफत',
    'तफर',
    'तफल',
    'तबक',
    'तबत',
    'तबर',
    'तबल',
    'तमक',
    'तमच',
    'तमज',
    'तमन',
    'तमर',
    'तमल',
    'तमस',
    'तयच',
    'तयत',
    'तयब',
    'तयर',
    'तरई',
    'तरक',
    'तरग',
    'तरच',
    'तरज',
    'तरट',
    'तरड',
    'तरण',
    'तरत',
    'तरन',
    'तरप',
    'तरफ',
    'तरब',
    'तरम',
    'तरर',
    'तरल',
    'तरळ',
    'तरस',
    'तरह',
    'तलई',
    'तलक',
    'तलख',
    'तलग',
    'तलज',
    'तलत',
    'तलद',
    'तलप',
    'तलफ',
    'तलब',
    'तलम',
    'तलर',
    'तलव',
    'तलश',
    'तळई',
    'तळच',
    'तळण',
    'तळत',
    'तळप',
    'तळम',
    'तळल',
    'तळळ',
    'तवग',
    'तवत',
    'तवन',
    'तवय',
    'तवर',
    'तवळ',
    'तशन',
    'तसई',
    'तसच',
    'तसड',
    'तसम',
    'तसर',
    'तसस',
    'तहच',
    'तहत',
    'तहद',
    'तहर',
    'तहस',
    'थआप',
    'थईम',
    'थकक',
    'थकज',
    'थकत',
    'थकल',
    'थकव',
    'थडग',
    'थतच',
    'थथथ',
    'थपथ',
    'थमच',
    'थमन',
    'थयच',
    'थयव',
    'थरच',
    'थरत',
    'थरर',
    'थलग',
    'थलल',
    'थलस',
    'थळप',
    'थवअ',
    'थवई',
    'थवड',
    'थवन',
    'थशप',
    'दईल',
    'दईस',
    'दकड',
    'दकन',
    'दकळ',
    'दखई',
    'दखत',
    'दखन',
    'दखर',
    'दखल',
    'दखळ',
    'दगट',
    'दगड',
    'दगत',
    'दगद',
    'दगर',
    'दगल',
    'दचक',
    'दठन',
    'दडक',
    'दडग',
    'दडण',
    'दडत',
    'दडप',
    'दडब',
    'दडर',
    'दडल',
    'दडस',
    'दणक',
    'दतक',
    'दतख',
    'दतर',
    'दथन',
    'ददई',
    'ददन',
    'ददर',
    'दधम',
    'दफण',
    'दफन',
    'दबई',
    'दबक',
    'दबत',
    'दबल',
    'दबस',
    'दभळ',
    'दमई',
    'दमक',
    'दमच',
    'दमट',
    'दमड',
    'दमण',
    'दमत',
    'दमद',
    'दमन',
    'दमर',
    'दमळ',
    'दमस',
    'दयक',
    'दयन',
    'दरक',
    'दरख',
    'दरच',
    'दरज',
    'दरड',
    'दरण',
    'दरत',
    'दरद',
    'दरप',
    'दरभ',
    'दरल',
    'दरळ',
    'दरव',
    'दरश',
    'दरस',
    'दलक',
    'दलख',
    'दलघ',
    'दलच',
    'दलड',
    'दलद',
    'दलन',
    'दलम',
    'दलल',
    'दलह',
    'दळण',
    'दळत',
    'दळन',
    'दळप',
    'दळल',
    'दळव',
    'दवच',
    'दवण',
    'दवर',
    'दवस',
    'दवह',
    'दशक',
    'दशत',
    'दशन',
    'दशम',
    'दशल',
    'दसई',
    'दसक',
    'दसत',
    'दसम',
    'दसर',
    'दहच',
    'दहण',
    'दहत',
    'दहन',
    'दहल',
    'धईर',
    'धकक',
    'धकड',
    'धकत',
    'धकर',
    'धकल',
    'धगड',
    'धगन',
    'धजक',
    'धजत',
    'धजद',
    'धजल',
    'धटक',
    'धडक',
    'धडख',
    'धडच',
    'धडत',
    'धडद',
    'धडप',
    'धडम',
    'धडर',
    'धडस',
    'धढक',
    'धतड',
    'धदक',
    'धधक',
    'धनक',
    'धनच',
    'धनज',
    'धनड',
    'धनद',
    'धनन',
    'धनम',
    'धनय',
    'धनव',
    'धफव',
    'धमक',
    'धमण',
    'धमन',
    'धमम',
    'धमव',
    'धरच',
    'धरण',
    'धरत',
    'धरन',
    'धरप',
    'धरम',
    'धरल',
    'धरव',
    'धळण',
    'धवज',
    'धवड',
    'धवण',
    'धवत',
    'धवन',
    'धवय',
    'धवल',
    'धवळ',
    'धवस',
    'धशत',
    'धसई',
    'धसच',
    'धसत',
    'धसन',
    'धहत',
    'धहन',
    'नईक',
    'नईद',
    'नईन',
    'नईफ',
    'नईब',
    'नईम',
    'नकट',
    'नकड',
    'नकत',
    'नकद',
    'नकम',
    'नकर',
    'नकल',
    'नकळ',
    'नकश',
    'नखच',
    'नखत',
    'नखर',
    'नगच',
    'नगद',
    'नगन',
    'नगप',
    'नगम',
    'नगर',
    'नगस',
    'नजक',
    'नजत',
    'नजद',
    'नजन',
    'नजफ',
    'नजम',
    'नजर',
    'नझज',
    'नझफ',
    'नझम',
    'नझर',
    'नझल',
    'नटच',
    'नटण',
    'नटत',
    'नटन',
    'नटर',
    'नटस',
    'नडक',
    'नडच',
    'नडत',
    'नढई',
    'नतन',
    'नतर',
    'नथच',
    'नथन',
    'नथर',
    'नदच',
    'नदत',
    'नदन',
    'नदर',
    'ननई',
    'ननद',
    'नपर',
    'नफज',
    'नफर',
    'नफस',
    'नबम',
    'नबर',
    'नबल',
    'नभच',
    'नमक',
    'नमत',
    'नमन',
    'नमल',
    'नमस',
    'नमह',
    'नयच',
    'नयत',
    'नयन',
    'नयम',
    'नयर',
    'नरक',
    'नरच',
    'नरज',
    'नरड',
    'नरद',
    'नरम',
    'नरल',
    'नरळ',
    'नरस',
    'नलद',
    'नळच',
    'नवई',
    'नवख',
    'नवच',
    'नवट',
    'नवड',
    'नवत',
    'नवद',
    'नवन',
    'नवफ',
    'नवब',
    'नवम',
    'नवर',
    'नवल',
    'नवव',
    'नवस',
    'नशद',
    'नसई',
    'नसच',
    'नसण',
    'नसत',
    'नसद',
    'नसन',
    'नसब',
    'नसर',
    'नसल',
    'नसव',
    'नहई',
    'नहन',
    'नहर',
    'नहल',
    'पअन',
    'पईट',
    'पईन',
    'पकक',
    'पकज',
    'पकट',
    'पकड',
    'पकत',
    'पकद',
    'पकन',
    'पकर',
    'पकल',
    'पकव',
    'पखक',
    'पखर',
    'पगट',
    'पगड',
    'पगत',
    'पगर',
    'पगल',
    'पगह',
    'पघच',
    'पघळ',
    'पचक',
    'पचच',
    'पचड',
    'पचत',
    'पचथ',
    'पचन',
    'पचर',
    'पचल',
    'पजई',
    'पजक',
    'पजल',
    'पझर',
    'पझल',
    'पटक',
    'पटच',
    'पटण',
    'पटत',
    'पटन',
    'पटम',
    'पटर',
    'पटल',
    'पटव',
    'पटस',
    'पठक',
    'पठण',
    'पठत',
    'पठन',
    'पडक',
    'पडग',
    'पडच',
    'पडड',
    'पडण',
    'पडत',
    'पडद',
    'पडम',
    'पडर',
    'पडल',
    'पडळ',
    'पडव',
    'पडस',
    'पढण',
    'पढत',
    'पढम',
    'पढव',
    'पणअ',
    'पणच',
    'पणज',
    'पणण',
    'पणत',
    'पणन',
    'पणव',
    'पतक',
    'पतच',
    'पतत',
    'पतन',
    'पतर',
    'पथक',
    'पथख',
    'पथत',
    'पथन',
    'पथम',
    'पथय',
    'पथर',
    'पदक',
    'पदच',
    'पदज',
    'पदत',
    'पदन',
    'पदम',
    'पदर',
    'पदल',
    'पदव',
    'पदश',
    'पधत',
    'पनई',
    'पनक',
    'पनण',
    'पनत',
    'पनन',
    'पनप',
    'पनय',
    'पनव',
    'पनस',
    'पपई',
    'पपण',
    'पपन',
    'पपय',
    'पफर',
    'पबक',
    'पबच',
    'पबत',
    'पबन',
    'पमन',
    'पयत',
    'पयल',
    'परक',
    'परख',
    'परच',
    'परज',
    'परड',
    'परण',
    'परत',
    'परद',
    'परन',
    'परब',
    'परम',
    'परर',
    'परल',
    'परळ',
    'परव',
    'परश',
    'परस',
    'पलई',
    'पलक',
    'पलख',
    'पलट',
    'पलत',
    'पलन',
    'पलम',
    'पलय',
    'पलव',
    'पलश',
    'पळक',
    'पळच',
    'पळण',
    'पळत',
    'पळथ',
    'पळन',
    'पळम',
    'पळय',
    'पळल',
    'पळव',
    'पळस',
    'पवई',
    'पवच',
    'पवण',
    'पवत',
    'पवन',
    'पवम',
    'पवय',
    'पवर',
    'पवल',
    'पवळ',
    'पशट',
    'पशन',
    'पसई',
    'पसक',
    'पसत',
    'पसन',
    'पसर',
    'पसव',
    'पहट',
    'पहड',
    'पहत',
    'पहन',
    'पहर',
    'पहल',
    'फअश',
    'फआद',
    'फआर',
    'फईज',
    'फईट',
    'फईद',
    'फईम',
    'फईल',
    'फकट',
    'फकत',
    'फकद',
    'फकर',
    'फकल',
    'फखर',
    'फगत',
    'फगन',
    'फचर',
    'फजट',
    'फजर',
    'फजल',
    'फझल',
    'फटक',
    'फटच',
    'फटन',
    'फटर',
    'फटस',
    'फडक',
    'फडच',
    'फडज',
    'फडण',
    'फडत',
    'फडल',
    'फडस',
    'फणन',
    'फणस',
    'फतक',
    'फतन',
    'फतह',
    'फथक',
    'फदक',
    'फदर',
    'फदल',
    'फधल',
    'फनत',
    'फनम',
    'फनल',
    'फनस',
    'फफल',
    'फमष',
    'फयझ',
    'फयत',
    'फरक',
    'फरख',
    'फरच',
    'फरज',
    'फरड',
    'फरत',
    'फरद',
    'फरन',
    'फरश',
    'फरष',
    'फरस',
    'फरह',
    'फलई',
    'फलक',
    'फलग',
    'फलच',
    'फलट',
    'फलत',
    'फलन',
    'फलम',
    'फलर',
    'फलह',
    'फळक',
    'फळच',
    'फळत',
    'फळस',
    'फवज',
    'फवद',
    'फशन',
    'फशर',
    'फशल',
    'फसग',
    'फसण',
    'फसत',
    'फसन',
    'फसल',
    'फसव',
    'फहज',
    'फहद',
    'फहर',
    'बअई',
    'बअर',
    'बआल',
    'बईत',
    'बईद',
    'बईल',
    'बकट',
    'बकत',
    'बकन',
    'बकम',
    'बकर',
    'बकल',
    'बकस',
    'बखत',
    'बखर',
    'बखळ',
    'बगई',
    'बगच',
    'बगड',
    'बगत',
    'बगम',
    'बगय',
    'बगर',
    'बगल',
    'बगळ',
    'बघअ',
    'बघच',
    'बघण',
    'बघत',
    'बघन',
    'बघल',
    'बघव',
    'बचक',
    'बचच',
    'बचट',
    'बचत',
    'बचन',
    'बचर',
    'बचव',
    'बजट',
    'बजत',
    'बजर',
    'बजल',
    'बजव',
    'बझच',
    'बझट',
    'बझर',
    'बटक',
    'बटग',
    'बटण',
    'बटत',
    'बटन',
    'बटर',
    'बटल',
    'बठक',
    'बडई',
    'बडक',
    'बडख',
    'बडग',
    'बडड',
    'बडत',
    'बडद',
    'बडम',
    'बडर',
    'बडल',
    'बडव',
    'बडस',
    'बढई',
    'बढत',
    'बढन',
    'बणज',
    'बणत',
    'बतख',
    'बतच',
    'बतन',
    'बतर',
    'बदक',
    'बदड',
    'बदढ',
    'बदत',
    'बदन',
    'बदम',
    'बदर',
    'बदल',
    'बदव',
    'बदस',
    'बधत',
    'बधन',
    'बधल',
    'बनच',
    'बनण',
    'बनत',
    'बनन',
    'बनप',
    'बनफ',
    'बनब',
    'बनय',
    'बनर',
    'बनल',
    'बनव',
    'बपक',
    'बपन',
    'बफन',
    'बफर',
    'बफल',
    'बबई',
    'बबण',
    'बबत',
    'बबन',
    'बबब',
    'बबर',
    'बबल',
    'बबळ',
    'बमद',
    'बमन',
    'बमय',
    'बमव',
    'बमस',
    'बयक',
    'बयन',
    'बयम',
    'बयस',
    'बरई',
    'बरक',
    'बरख',
    'बरग',
    'बरच',
    'बरट',
    'बरड',
    'बरण',
    'बरत',
    'बरन',
    'बरप',
    'बरफ',
    'बरम',
    'बरय',
    'बरळ',
    'बरव',
    'बरस',
    'बरह',
    'बलई',
    'बलक',
    'बलख',
    'बलग',
    'बलच',
    'बलत',
    'बलद',
    'बलन',
    'बलब',
    'बलम',
    'बलष',
    'बळक',
    'बळख',
    'बळग',
    'बळच',
    'बळत',
    'बळद',
    'बळध',
    'बळप',
    'बळस',
    'बवअ',
    'बवई',
    'बवर',
    'बशर',
    'बशल',
    'बषल',
    'बसई',
    'बसक',
    'बसच',
    'बसण',
    'बसत',
    'बसन',
    'बसप',
    'बसम',
    'बसर',
    'बसल',
    'बसव',
    'बसस',
    'बसह',
    'बहक',
    'बहग',
    'बहत',
    'बहन',
    'बहर',
    'बहल',
    'बहव',
    'बहस',
    'भआग',
    'भआन',
    'भईन',
    'भकड',
    'भकत',
    'भकन',
    'भकम',
    'भकर',
    'भकल',
    'भगज',
    'भगण',
    'भगत',
    'भगन',
    'भगम',
    'भगर',
    'भगल',
    'भगव',
    'भगस',
    'भजक',
    'भजड',
    'भजत',
    'भजन',
    'भजप',
    'भजय',
    'भजव',
    'भझल',
    'भटक',
    'भटच',
    'भटट',
    'भडक',
    'भडस',
    'भणक',
    'भदई',
    'भदत',
    'भदर',
    'भनक',
    'भनत',
    'भभई',
    'भमण',
    'भयच',
    'भयण',
    'भयम',
    'भयह',
    'भरई',
    'भरक',
    'भरच',
    'भरज',
    'भरड',
    'भरण',
    'भरत',
    'भरथ',
    'भरन',
    'भरब',
    'भरभ',
    'भरम',
    'भरल',
    'भरव',
    'भलई',
    'भलत',
    'भलर',
    'भवई',
    'भवड',
    'भवत',
    'भवन',
    'भवर',
    'भवल',
    'भषक',
    'भषण',
    'भसम',
    'भसळ',
    'भहय',
    'मअज',
    'मअफ',
    'मईक',
    'मईच',
    'मईत',
    'मकई',
    'मकड',
    'मकन',
    'मकम',
    'मकर',
    'मकल',
    'मखण',
    'मखय',
    'मखर',
    'मगच',
    'मगज',
    'मगड',
    'मगण',
    'मगत',
    'मगध',
    'मगन',
    'मगम',
    'मगर',
    'मगल',
    'मगस',
    'मघई',
    'मघम',
    'मघर',
    'मचक',
    'मचच',
    'मचप',
    'मचल',
    'मजई',
    'मजक',
    'मजच',
    'मजज',
    'मजत',
    'मजब',
    'मजम',
    'मजर',
    'मजल',
    'मजस',
    'मझर',
    'मझल',
    'मटक',
    'मटण',
    'मटन',
    'मटर',
    'मटल',
    'मठच',
    'मठठ',
    'मठद',
    'मठम',
    'मडई',
    'मडक',
    'मडप',
    'मडम',
    'मडर',
    'मडल',
    'मडळ',
    'मडव',
    'मढत',
    'मढव',
    'मणई',
    'मणक',
    'मणच',
    'मतच',
    'मतद',
    'मतन',
    'मतफ',
    'मतम',
    'मतय',
    'मतर',
    'मतल',
    'मथई',
    'मथक',
    'मथन',
    'मदक',
    'मदच',
    'मदज',
    'मदण',
    'मदत',
    'मदद',
    'मदन',
    'मदम',
    'मदय',
    'मदर',
    'मदल',
    'मधच',
    'मधन',
    'मधब',
    'मधम',
    'मधय',
    'मधल',
    'मनई',
    'मनच',
    'मनत',
    'मनद',
    'मनन',
    'मनफ',
    'मनम',
    'मनल',
    'मनव',
    'मनश',
    'मनस',
    'मपक',
    'मपघ',
    'मपण',
    'मपध',
    'मफक',
    'मफत',
    'मफल',
    'मबई',
    'मबड',
    'मबफ',
    'मबल',
    'मभळ',
    'ममई',
    'ममक',
    'ममत',
    'ममन',
    'ममप',
    'ममर',
    'ममव',
    'ममश',
    'ममह',
    'मयक',
    'मयच',
    'मयज',
    'मयत',
    'मयद',
    'मयम',
    'मरक',
    'मरग',
    'मरच',
    'मरज',
    'मरड',
    'मरण',
    'मरत',
    'मरद',
    'मरन',
    'मरम',
    'मरल',
    'मरळ',
    'मलई',
    'मलक',
    'मलग',
    'मलज',
    'मलत',
    'मलन',
    'मलभ',
    'मलम',
    'मलय',
    'मलर',
    'मलव',
    'मळई',
    'मळग',
    'मळच',
    'मळण',
    'मळत',
    'मळद',
    'मळब',
    'मळभ',
    'मळम',
    'मळय',
    'मळल',
    'मळव',
    'मवई',
    'मवन',
    'मवर',
    'मवळ',
    'मशक',
    'मशन',
    'मशफ',
    'मशर',
    'मशळ',
    'मसई',
    'मसज',
    'मसण',
    'मसद',
    'मसन',
    'मसब',
    'मसल',
    'मसळ',
    'महक',
    'महग',
    'महज',
    'महड',
    'महत',
    'महद',
    'महन',
    'महब',
    'महम',
    'महर',
    'महल',
    'महश',
    'महस',
    'यअर',
    'यआज',
    'यईद',
    'यईल',
    'यकच',
    'यकब',
    'यकर',
    'यगड',
    'यगत',
    'यगद',
    'यजत',
    'यजद',
    'यजन',
    'यणस',
    'यतन',
    'यतय',
    'यतर',
    'यनम',
    'यपअ',
    'यमक',
    'यमच',
    'यमण',
    'यमन',
    'यमर',
    'यमल',
    'ययय',
    'यरल',
    'यरह',
    'यलप',
    'यवक',
    'यवत',
    'यवन',
    'यवर',
    'यवह',
    'यशक',
    'यशच',
    'यशम',
    'यशस',
    'यसह',
    'यहग',
    'यहर',
    'रअढ',
    'रअण',
    'रईच',
    'रईज',
    'रईझ',
    'रईत',
    'रईन',
    'रईफ',
    'रईल',
    'रईश',
    'रईस',
    'रकट',
    'रकण',
    'रकत',
    'रकम',
    'रकर',
    'रकल',
    'रखआ',
    'रखड',
    'रखण',
    'रखत',
    'रखल',
    'रगच',
    'रगड',
    'रगण',
    'रगत',
    'रगन',
    'रगम',
    'रगर',
    'रचज',
    'रचत',
    'रचन',
    'रचम',
    'रचल',
    'रजई',
    'रजक',
    'रजत',
    'रजन',
    'रजब',
    'रजय',
    'रजर',
    'रजस',
    'रझई',
    'रझक',
    'रटत',
    'रटर',
    'रडक',
    'रडण',
    'रडत',
    'रडन',
    'रडर',
    'रडल',
    'रडव',
    'रणक',
    'रणम',
    'रणव',
    'रणश',
    'रतज',
    'रतन',
    'रतर',
    'रतल',
    'रथच',
    'रथन',
    'रथम',
    'रथर',
    'रदद',
    'रदन',
    'रदय',
    'रदर',
    'रधम',
    'रनच',
    'रनट',
    'रनन',
    'रनप',
    'रनर',
    'रनस',
    'रपट',
    'रपव',
    'रफत',
    'रफद',
    'रफल',
    'रबई',
    'रबड',
    'रबत',
    'रबर',
    'रबल',
    'रभस',
    'रमई',
    'रमच',
    'रमड',
    'रमण',
    'रमत',
    'रमद',
    'रमन',
    'रमर',
    'रमल',
    'रमव',
    'रयत',
    'रयल',
    'ररत',
    'ररर',
    'रलव',
    'रलस',
    'रळढ',
    'रळत',
    'रवण',
    'रवथ',
    'रवद',
    'रवन',
    'रवर',
    'रवल',
    'रवळ',
    'रशद',
    'रशन',
    'रशर',
    'रषद',
    'रसआ',
    'रसई',
    'रसक',
    'रसच',
    'रसत',
    'रसद',
    'रसन',
    'रसप',
    'रसम',
    'रसर',
    'रसल',
    'रहक',
    'रहण',
    'रहत',
    'रहन',
    'रहम',
    'रहर',
    'रहश',
    'रहस',
    'लअण',
    'लईक',
    'लईख',
    'लईच',
    'लईत',
    'लईम',
    'लईश',
    'लईस',
    'लकच',
    'लकब',
    'लकम',
    'लकर',
    'लकश',
    'लखण',
    'लखन',
    'लखम',
    'लगच',
    'लगज',
    'लगट',
    'लगड',
    'लगत',
    'लगद',
    'लगन',
    'लगब',
    'लगभ',
    'लगम',
    'लगर',
    'लगस',
    'लघट',
    'लघर',
    'लघळ',
    'लचक',
    'लचर',
    'लचस',
    'लजत',
    'लजर',
    'लटक',
    'लटड',
    'लटम',
    'लटर',
    'लटह',
    'लठठ',
    'लडक',
    'लडच',
    'लडत',
    'लडद',
    'लडन',
    'लडर',
    'लढई',
    'लढण',
    'लढत',
    'लढल',
    'लढव',
    'लतआ',
    'लथन',
    'लथर',
    'लदर',
    'लपक',
    'लपट',
    'लपण',
    'लपत',
    'लपन',
    'लपल',
    'लपव',
    'लफड',
    'लबक',
    'लबग',
    'लबन',
    'लबस',
    'लभड',
    'लभत',
    'लमक',
    'लमन',
    'लयच',
    'लयण',
    'लयन',
    'लरप',
    'ललअ',
    'ललई',
    'ललक',
    'ललत',
    'ललन',
    'लळत',
    'लवक',
    'लवण',
    'लवत',
    'लवन',
    'लवर',
    'लवल',
    'लशन',
    'लषण',
    'लसच',
    'लसण',
    'लसत',
    'लसन',
    'लहन',
    'लहम',
    'लहर',
    'ळकर',
    'ळजड',
    'वईच',
    'वईट',
    'वईथ',
    'वईस',
    'वकग',
    'वकत',
    'वकब',
    'वकर',
    'वकल',
    'वकश',
    'वखत',
    'वखर',
    'वगत',
    'वगद',
    'वगध',
    'वगर',
    'वगळ',
    'वघई',
    'वघड',
    'वघत',
    'वघळ',
    'वचक',
    'वचत',
    'वचन',
    'वचप',
    'वजक',
    'वजड',
    'वजत',
    'वजन',
    'वजम',
    'वजय',
    'वजल',
    'वजव',
    'वजह',
    'वझर',
    'वटक',
    'वटच',
    'वटत',
    'वटप',
    'वटर',
    'वटल',
    'वठच',
    'वठत',
    'वठल',
    'वठव',
    'वडई',
    'वडज',
    'वडत',
    'वडद',
    'वडन',
    'वडप',
    'वडर',
    'वडस',
    'वडह',
    'वढई',
    'वढत',
    'वढव',
    'वणई',
    'वणन',
    'वणर',
    'वणळ',
    'वतन',
    'वतल',
    'वथम',
    'वदक',
    'वदत',
    'वदन',
    'वदप',
    'वदय',
    'वदर',
    'वदल',
    'वधच',
    'वधत',
    'वनई',
    'वनग',
    'वनच',
    'वनज',
    'वनड',
    'वनफ',
    'वनस',
    'वपण',
    'वपन',
    'वपर',
    'वफर',
    'वभव',
    'वमन',
    'वयक',
    'वयच',
    'वयम',
    'वयर',
    'वरई',
    'वरक',
    'वरच',
    'वरड',
    'वरढ',
    'वरण',
    'वरत',
    'वरद',
    'वरध',
    'वरन',
    'वरप',
    'वरम',
    'वरय',
    'वरळ',
    'वरव',
    'वरश',
    'वरष',
    'वरस',
    'वलई',
    'वलज',
    'वलण',
    'वलत',
    'वलद',
    'वलन',
    'वलप',
    'वलय',
    'वलव',
    'वलस',
    'वळई',
    'वळक',
    'वळख',
    'वळण',
    'वळत',
    'वळन',
    'वळप',
    'वळय',
    'वळल',
    'वळव',
    'वळस',
    'ववर',
    'वशज',
    'वशट',
    'वषत',
    'वसई',
    'वसक',
    'वसण',
    'वसत',
    'वसद',
    'वसन',
    'वसम',
    'वसल',
    'वसव',
    'वहट',
    'वहन',
    'वहब',
    'वहम',
    'वहर',
    'वहल',
    'शअण',
    'शअर',
    'शआर',
    'शईक',
    'शकक',
    'शकच',
    'शकट',
    'शकण',
    'शकत',
    'शकय',
    'शकर',
    'शकल',
    'शखस',
    'शगण',
    'शगर',
    'शगल',
    'शजर',
    'शटक',
    'शटन',
    'शटर',
    'शटल',
    'शतक',
    'शतम',
    'शतर',
    'शथप',
    'शदत',
    'शदद',
    'शदर',
    'शनच',
    'शनर',
    'शनल',
    'शपत',
    'शपथ',
    'शपद',
    'शपध',
    'शपश',
    'शफक',
    'शफत',
    'शफथ',
    'शफय',
    'शफर',
    'शफल',
    'शबद',
    'शबन',
    'शबय',
    'शबर',
    'शबल',
    'शभर',
    'शमक',
    'शमत',
    'शमन',
    'शमम',
    'शमय',
    'शमर',
    'शमल',
    'शमव',
    'शमस',
    'शयन',
    'शयय',
    'शयर',
    'शरच',
    'शरज',
    'शरट',
    'शरण',
    'शरत',
    'शरथ',
    'शरद',
    'शरन',
    'शरप',
    'शरफ',
    'शरभ',
    'शरम',
    'शरय',
    'शरश',
    'शरस',
    'शलब',
    'शलभ',
    'शलल',
    'शलह',
    'शवच',
    'शवथ',
    'शवद',
    'शवन',
    'शवम',
    'शशक',
    'शशर',
    'शशव',
    'शसन',
    'शहच',
    'शहड',
    'शहत',
    'शहद',
    'शहन',
    'शहर',
    'षकत',
    'षकल',
    'षटक',
    'षटप',
    'षडज',
    'षफथ',
    'षभर',
    'षरद',
    'षलस',
    'सअद',
    'सअर',
    'सआथ',
    'सआद',
    'सईई',
    'सईक',
    'सईच',
    'सईज',
    'सईड',
    'सईत',
    'सईद',
    'सईन',
    'सईफ',
    'सईब',
    'सईम',
    'सईर',
    'सईल',
    'सईव',
    'सईश',
    'सईष',
    'सईस',
    'सकट',
    'सकत',
    'सकन',
    'सकय',
    'सकर',
    'सकल',
    'सकळ',
    'सकव',
    'सकस',
    'सखत',
    'सखन',
    'सखर',
    'सखल',
    'सखळ',
    'सगज',
    'सगट',
    'सगत',
    'सगन',
    'सगम',
    'सगर',
    'सगल',
    'सगळ',
    'सगह',
    'सघन',
    'सघल',
    'सचक',
    'सचन',
    'सचय',
    'सचर',
    'सचल',
    'सचश',
    'सजक',
    'सजग',
    'सजज',
    'सजण',
    'सजत',
    'सजद',
    'सजन',
    'सजप',
    'सजम',
    'सजय',
    'सजर',
    'सजल',
    'सजळ',
    'सजव',
    'सजह',
    'सझम',
    'सटक',
    'सटन',
    'सटप',
    'सटर',
    'सटल',
    'सडक',
    'सडण',
    'सडत',
    'सडन',
    'सढख',
    'सढल',
    'सढळ',
    'सणई',
    'सणक',
    'सणच',
    'सणस',
    'सतक',
    'सतच',
    'सतज',
    'सतत',
    'सतन',
    'सतय',
    'सतर',
    'सतस',
    'सतह',
    'सदत',
    'सदन',
    'सदफ',
    'सदम',
    'सदय',
    'सदर',
    'सदल',
    'सदळ',
    'सदस',
    'सदह',
    'सधन',
    'सधर',
    'सनई',
    'सनक',
    'सनग',
    'सनच',
    'सनत',
    'सनथ',
    'सनद',
    'सनन',
    'सनप',
    'सनम',
    'सनय',
    'सनल',
    'सनव',
    'सनस',
    'सनह',
    'सपक',
    'सपच',
    'सपट',
    'सपत',
    'सपथ',
    'सपन',
    'सपर',
    'सपल',
    'सफई',
    'सफत',
    'सफन',
    'सफर',
    'सफल',
    'सफळ',
    'सबक',
    'सबज',
    'सबत',
    'सबथ',
    'सबद',
    'सबध',
    'सबन',
    'सबब',
    'सबम',
    'सबर',
    'सबल',
    'सबळ',
    'सबव',
    'सबस',
    'सबह',
    'सभआ',
    'सभई',
    'सभन',
    'सभय',
    'सभर',
    'सभव',
    'समई',
    'समक',
    'समच',
    'समज',
    'समझ',
    'समण',
    'समत',
    'समद',
    'समध',
    'समन',
    'समप',
    'समभ',
    'समम',
    'समय',
    'समर',
    'समल',
    'समळ',
    'समस',
    'समह',
    'सयद',
    'सयन',
    'सयम',
    'सयर',
    'सयल',
    'सयव',
    'सरई',
    'सरक',
    'सरख',
    'सरग',
    'सरच',
    'सरज',
    'सरठ',
    'सरण',
    'सरत',
    'सरथ',
    'सरद',
    'सरन',
    'सरप',
    'सरफ',
    'सरब',
    'सरभ',
    'सरम',
    'सरर',
    'सरल',
    'सरळ',
    'सरव',
    'सरश',
    'सरस',
    'सरह',
    'सलई',
    'सलक',
    'सलग',
    'सलच',
    'सलत',
    'सलद',
    'सलन',
    'सलभ',
    'सलम',
    'सलल',
    'सलळ',
    'सलस',
    'सळई',
    'सळग',
    'सळत',
    'सवई',
    'सवघ',
    'सवच',
    'सवड',
    'सवण',
    'सवत',
    'सवद',
    'सवध',
    'सवन',
    'सवब',
    'सवम',
    'सवय',
    'सवर',
    'सवल',
    'सवळ',
    'सवव',
    'सवश',
    'सवष',
    'सवस',
    'सशय',
    'सशल',
    'सशस',
    'ससक',
    'ससत',
    'ससन',
    'ससस',
    'ससह',
    'सहक',
    'सहघ',
    'सहच',
    'सहज',
    'सहढ',
    'सहण',
    'सहत',
    'सहद',
    'सहन',
    'सहम',
    'सहय',
    'सहर',
    'सहल',
    'सहळ',
    'सहस',
    'हआत',
    'हईच',
    'हकक',
    'हकत',
    'हकन',
    'हकम',
    'हकल',
    'हगत',
    'हगर',
    'हगल',
    'हचल',
    'हजड',
    'हजम',
    'हजर',
    'हजल',
    'हजस',
    'हजह',
    'हझर',
    'हझल',
    'हटक',
    'हटट',
    'हटण',
    'हटत',
    'हटन',
    'हटप',
    'हटल',
    'हटव',
    'हटस',
    'हडत',
    'हडप',
    'हडल',
    'हडळ',
    'हडस',
    'हढत',
    'हणज',
    'हणन',
    'हतई',
    'हतर',
    'हथन',
    'हदच',
    'हदथ',
    'हदद',
    'हदफ',
    'हदय',
    'हदर',
    'हदल',
    'हनक',
    'हनण',
    'हनन',
    'हनम',
    'हनस',
    'हपड',
    'हपभ',
    'हफक',
    'हबक',
    'हबच',
    'हबफ',
    'हबल',
    'हबळ',
    'हभप',
    'हमच',
    'हमत',
    'हमद',
    'हमन',
    'हमम',
    'हमर',
    'हमल',
    'हमस',
    'हयच',
    'हयद',
    'हयस',
    'हरक',
    'हरख',
    'हरज',
    'हरड',
    'हरण',
    'हरत',
    'हरद',
    'हरन',
    'हरब',
    'हरम',
    'हरर',
    'हरल',
    'हरळ',
    'हरव',
    'हरश',
    'हरष',
    'हलक',
    'हलत',
    'हलद',
    'हलन',
    'हलब',
    'हलम',
    'हलर',
    'हलल',
    'हलव',
    'हळच',
    'हळज',
    'हळड',
    'हळद',
    'हळब',
    'हळव',
    'हवई',
    'हवक',
    'हवच',
    'हवत',
    'हवन',
    'हवफ',
    'हवम',
    'हवय',
    'हवर',
    'हवल',
    'हवळ',
    'हवस',
    'हशत',
    'हशद',
    'हशन',
    'हशम',
    'हशर',
    'हषष',
    'हसक',
    'हसण',
    'हसत',
    'हसद',
    'हसन',
    'हसम',
    'हसर',
    'सधन',
    'अक्षर',
    'सक्षम',
    'पथक',
    'साधन',
    'आरसा',
    'साक्षर',
    'सासर',
    'शरद',
    'शारदा',
    'भक्षक',
    'ऐपत',

    'जळण',
    'सळई',
    // 'आवर',
    'आयत',
    'वमन',
    'दमट',
    'नरक',
    'अटळ',
    'गवत',
    'जनक',
    'वरण',
    'बचत',
    // 'अनल',
    'तगर',
    'वजन',
    'ठळक',
    'कदर',
    'चवड',
    'पचन',
    'बगल',
    'तडफ',
    'नगद',
    'मटण',
    'रसद',
    'कलम',
    'सनद',
    'अजब',
    'नवस',
    'सफल',
    'तबक',
    // 'कळव',
    'कमळ',
    'वसन',
    'घडण',
    'सखल',
    'मरण',
    'वचक',
    'बलक',
    'शरम',
    'समय',
    'वतन',
    'गजर',
    'लकब',
    'आवई',
    'मदत',
    'समर',
    'चरक',
    'सधन',
    'मळभ',
    // 'डझन',
    'बखर',
    'दखल',
    'खवट',
    'सलग',
    'बदल',
    // 'तनय',
    'परम',
    'मजल',
    'घटक',
    'झडप',
    'धवल',
    'चरस',
    'पदर',
    'आवक',
    'गडद',
    'जठर',
    'यवन',
    'हरण',
    'मलम',
    'सहज',
    'तडक',
    'रजई',
    'झलक',
    'दरड',
    'ललत',
    'भक्षण',
    'बदक',
    'बखळ',
    'फरक',
    'अभय',
    'जवळ',
    'वरद',
    'शरण',
    'मयत',
    'चटई',
    // 'गमन',
    'जबर',
    'नमन',
    'मगर',
    'यमक',
    'वळण',
    'अक्षर',
    'दमन',
    'जरब',
    'लक्षण',
    'मनन',
    // 'मगध',
    'नरम',
    // 'अदब',
    'यमन',
    'पतन',
    'शरद',
    'मखर',
    'आफत',
    'समई',
    // 'कफन',
    'लटक',
    'चरण',
    'कडक',
    'सफर',
    'भडक',
    'अजय',
    'दफन',
    'सदन',
    'चपळ',
    'आवड',
    // 'चळत',
    'कणव',
    // 'रमल',
    'वदन',
    'गरळ',
    'कढण',
    'सवड',
    'खबर',
    'आकस',
    'पटल',
    'आदब',
    'पदक',
    'सतत',
    // 'गजल',
    'लगट',
    'षटक',
    'रक्षण',
    'रक्षक',
    // 'मसण',
    // 'कळत',
    'आगळ',
    'सजग',
    'नवल',
    'कळस',
    // 'भरत',
    'कलह',
    'लवण',
    'कढई',
    'अधम',
    'सरण',
    'सहन',
    'अथक',
    'अक्षय',
    'तलफ',
    // 'शमन',
    'जगत',
    'सनई',
    'चमक',
    'कढत',
    'खडक',
    'कथक',
    'फलक',
    'अमर',
    'कनक',
    // 'मगज',
    'पवन',
    'लचक',
    'भजन',
    'अचल',
    'गरज',
    'आदर',
    'कमल',
    'आधण',
    'मलई',
    'आगर',
    // 'कमर',
    'टणक',
    'शपथ',
    'धरण',
    'भवन',
    'चटक',
    'बटण',
    'नयन',
    'कवच',
    'तलम',
    'कसब',
    'गमक',
    'भगर',
    'सणक',
    'कपट',
    'अरब',
    'बहर',
    'जखम',
    // 'अबब',
    'मलय',
    'अडत',
    'पकड',
    'नगर',
    'फणस',
    'कवन',
    'अपक्ष',
    'कलश',
    'सवत',
    'सरळ',
    'पठण',
    // 'गझल',
    'हवन',
    'कवठ',
    'कलप',
    // 'आठव',
    'दशक',
    'समक्ष',
    'कसर',
    'पथक',
    'परत',
    'चलन',
    'जतन',
    'लढत',
    'दळण',
    'मकर',
    'सवय',
    'कहर',
    'जवस',
    'शहर',
    // 'असर',
    'रजत',
    // 'रजक',
    'समज',
    'चढण',
    'अटक',
    'आळस',
    'परस',
    'आरव',
    'कळप',
    // 'महल',
    'शतक',
    'सकल',
    'आसन',
    'वलय',
    'वचन',
    'गवई',
    'गहन',
    'जलद',
    'शयन',
    'जहर',
    'अढळ',
    'घसट',
    'धडक',
    'पळस',
    'हडळ',
    'दगड',
    'सकस',
    'कबर',
    'मदन',
    'सहल',
    'दहन',
    'लहर',
    'तरस',
    'कथन',
    'चषक',
    'सक्षम',
    'आशय',
    'अधर',
    'रयत',
    'नजर',
    'वहन',
    //
    'इतर',
    'इसम',
    'इसब',
    'उकड',
    'उकल',
    'उखळ',
    'उगम',
    'उघड',
    'उचल',
    'उजळ',
    'उथळ',
    'उदक',
    'उदय',
    'उदर',
    'उबग',
    'उबळ',
    'उभट',
    'उभय',
    'उमज',
    'उरक',
    'उलट',
    'उसण',
    'उसळ',
    'ऋषभ',
    'एकर',
    'ऐरण',
    'ऐवज',
    'ओशट',
    'ओघळ',
    'ओहळ',
    'ओळख',
    'औरस',
    'औषध',
    'औक्षण',
    'अंगण',
    'अंजन',
    'अंतर',
    'अंबर',
    'ऐपत',
    // added after the fact (based on user reactions) on 15 March -- these are not there is the dictionary
    'अंमल',
    'अंमळ',
    'ओरड',
    'ओझर',
]
